import React from "react";
import { Carousel } from "antd";
import "./BIDCarousel.css";

export default function BIDCarousel({ children }) {
  return (
    <div className="bid-carousel-container">
      <Carousel autoplay autoplaySpeed={10000}>
        {children}
      </Carousel>
    </div>
  );
}
